<template>
  <!-- 首年梯度加费 -->
  <div>
    <Modal v-model="visible" width="800px" title="梯度加费配置示例" :footer-hide="true" :mask-closable="false" class="my-modal">
      <div class="table" style="margin-top:20px">
        <div class="tr">
          <div class="td th td1">
            条件方案
            <p class="info-text" v-if="conditionType == 1">(X=累计规模保费)</p>
            <p class="info-text" v-if="conditionType == 2">(X=累计标准保费)</p>
          </div>
          <div class="table-box td23">
            <div class="tr">
              <div class="td th td2">目标方案</div>
              <div class="td th td3">费用率（%）</div>
            </div>
          </div>
        </div>
        <div class="tr" v-for="row in gradientItemList" :key="row.key">
          <div class="td td1">
            <span>{{ row.conditionStart }}</span>
            <span v-if="row.conditionStartSymbol == 1">{{ '<' }}</span>
            <span v-if="row.conditionStartSymbol == 2">{{ '≤' }}</span>
            <span>X</span>
            <span v-if="row.conditionEndSymbol == 1">{{ '<' }}</span>
            <span v-if="row.conditionEndSymbol == 2">{{ '≤' }}</span>
            <span>{{ row.conditionEnd }}</span>
          </div>
          <div class="table-box td23">
            <div class="tr" v-for="item in row.programCommissionList" :key="item.key">
              <div class="td td2">{{ item.programNames.join('，') }}</div>
              <div class="td td3">{{ item.commission }}</div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
  
<script>
export default {
  mixins: [],
  components: {},
  props: {
  },
  data() {
    return {
      visible: false,
      conditionType: 1,
      gradientItemList: [
        {
          key: 'a1',
          conditionStart: '10000',
          conditionStartSymbol: '1',
          conditionType: 1,
          conditionEndSymbol: '2',
          conditionEnd: '20000',
          programCommissionList: [
            { key: 'b1', programNames: ['方案一'], commission: '1' },
            { key: 'b2', programNames: ['方案二', '方案三'], commission: '2' },
          ]
        },
        {
          key: 'a2',
          conditionStart: '20000',
          conditionStartSymbol: '1',
          conditionType: 1,
          conditionEndSymbol: '2',
          conditionEnd: '30000',
          programCommissionList: [
            { key: 'b1', programNames: ['方案一'], commission: '2' },
            { key: 'b2', programNames: ['方案二', '方案三'], commission: '3' },
          ]
        },
        {
          key: 'a3',
          conditionStart: '30000',
          conditionStartSymbol: '1',
          conditionType: 1,
          conditionEndSymbol: '2',
          conditionEnd: '40000',
          programCommissionList: [
            { key: 'b1', programNames: ['方案一'], commission: '3' },
            { key: 'b2', programNames: ['方案二', '方案三'], commission: '4' },
          ]
        }
      ]
    };
  },
  computed: {},
  created() {},
  methods: {
    close() {
      this.visible = false;
    },
    open() {
      this.visible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
.table {
  width: 100%;
}
.td1 {
  flex: 300px;
}
.td2 {
  flex: 200px;
}
.td3 {
  flex: 100px;
}
.td23 {
  flex: 300px;
}
</style>  